module.exports = __webpack_public_path__ + "images/category_lp/jewel/new/assessment_achievements/1@2x_06f7fb6a43d265112f070f7fb7a5eb85.png";